import { useEffect } from 'react';
import { useLoading } from '~/lib/contexts/LoadingContext';

export const GlobalLinkInterceptor = () => {
    const { showSpinner, hideSpinner } = useLoading();

    useEffect(() => {
        const handleClick = (event: MouseEvent) => {
            const target = event.target as HTMLElement;

            // Find the closest element with data-spinner="true" or link element
            const spinnerElement = target.closest('[data-spinner="true"]');
            const link = spinnerElement || target.closest('a[href]');

            if (link) {
                // Check if the element has data-spinner attribute
                const shouldShowSpinner = link.getAttribute('data-spinner') === 'true';

                if (shouldShowSpinner && typeof window !== 'undefined') {
                    // Get the current URL and the element's href if present
                    const currentUrl = window.location.pathname + window.location.search;
                    const linkHref = link.getAttribute('href');

                    // Show spinner if it's a non-link element or a link going to a different URL
                    if (!linkHref || linkHref !== currentUrl) {
                        // Check if this is a new tab/window click (Ctrl+click, Cmd+click, middle click)
                        const isNewTabClick = event.ctrlKey || event.metaKey || event.button === 1;

                        if (isNewTabClick) {
                            // For new tab clicks, don't show spinner since we're not navigating away
                            return;
                        }

                        showSpinner();
                    }
                }
            }
        };

        // Add event listener to document
        document.addEventListener('click', handleClick);

        // Cleanup
        return () => {
            document.removeEventListener('click', handleClick);
        };
    }, [showSpinner, hideSpinner]);

    return null; // This component doesn't render anything
};
